import { VolumetricAnalysis, SentimentalAnalysis } from "./routes";

export default [SentimentalAnalysis, VolumetricAnalysis];
